import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState,  } from 'appredux';

import {   KarnetDoladowania, KarnetZjazdy } from 'api';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';




import {  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { Trans } from 'react-i18next';

//PM 2021-10-21
//wstrzykniecie tylko uzywanych pol z magazynu danych
//wyrzucenie ladowanie
interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,

    randomNum: number,
    doladowanie: KarnetDoladowania,
}

interface DialogState {
    open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    //PM 2021-09-17
    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            open: true
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.randomNum !== prevProps.randomNum){
            this.setState({open: true})
        }
    }

    closeConfirm = () => {
        this.setState({ open: false });
    };

    // ukryjPracownika = async () => {
    //     this.closeConfirm()
    //     this.props.ukryjPracownika(this.props.pracownik)
    // };


    render() {
        const classes = this.props.classes;

        console.log(this.props.doladowanie)

        return (
            <>
                <Dialog
                    //disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.open}
                    onEscapeKeyDown={this.closeConfirm}
                    onBackdropClick={this.closeConfirm}
                    fullWidth
                >
                    <DialogTitle disableTypography className={classes.paddingBottom0}>
                        <Typography gutterBottom variant="h6" component="h2" color="primary"
                            className={`${classes.primary} ${classes.headline}`}>
                            <b style={{ textTransform: "lowercase" }}><Trans>pokaż info</Trans></b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className={classes.dialogContentText} >
                            {"opis"}<b className={`${classes.primary} ${classes.right}`}>{this.props.doladowanie.jrWplataDefWwwOpis}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"kwota"}<b className={`${classes.primary} ${classes.right}`}>{this.props.doladowanie.wplata + " pln"}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"logo"}<b className={`${classes.primary} ${classes.right}`}>{this.props.doladowanie.ekartaLogo}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"data operacji"}<b className={`${classes.primary} ${classes.right}`}>{this.props.doladowanie.dataOperacji}</b>
                        </DialogContentText> 
                        
                        {/* <DialogContentText className={classes.dialogContentText} >
                            {"zamek_id"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.zamekId}</b>
                        </DialogContentText>

                        <DialogContentText className={classes.dialogContentText} >
                            {"opis"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.lockAlias}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"akcja"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.zamekAkcjaOpis}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"passcode"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.passcode}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"card_id"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.cardId}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"card_name"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.cardName}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wazne_od"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.waznyOd}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wazne_do"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.waznyDo}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wysłany"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.wyslany}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wysłany_ilość_prób"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.wyslanyIloscProb}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wysłany_error_code"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.wyslanyErrorCode}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"sprawdzony"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.errorCodeSprawdzony}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"odroczony"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.odroczony}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"do_wysłania"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.doWyslania}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"baza"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.zamekBazaOpis}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"kto"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.ktoNazwisko}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"pobyt_id"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.pobytId}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"dodano_dt"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.dodanoDt}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"wyslano_dt"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.wyslanoDt}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"dt"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.dt}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"do_likw"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.doLikw}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"czas"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.czas}</b>
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"czas_opis"}<b className={`${classes.primary} ${classes.right}`}>{this.props.passcode.czasOpis}</b>
                        </DialogContentText> */}
                    </DialogContent>

                    <DialogActions>
                        <Button variant={'outlined'} color="primary" size="small" className={classes.button}
                            onClick={this.closeConfirm}>
                            <b><Trans>Back</Trans></b>
                        </Button>
                        {/* <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.ukryjPracownika}>
                            <b>zapisz</b>
                        </Button> */}
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        //fontSize: "16px",
        //fontWeight: 600
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        fontSize: theme.typography.body1.fontSize,
        fontFamily: theme.typography.body1.fontFamily,
        fontWeight: theme.typography.body1.fontWeight,
        lineHeight: theme.typography.body1.lineHeight,
        letterSpacing: theme.typography.body1.letterSpacing,
        marginBottom: '12px'
        //fontSize: "14px"
      },
      button: {
        textTransform: "none" as "none"
    },
    right: {
        float: "right" as "right"
    }
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

